


































































import { Component, Prop, Vue } from "vue-property-decorator";
import { isIOS } from "@/lib/browserUtils";
import BaseSpinner from "@/components/BaseSpinner";
Vue.component("BaseSpinner", BaseSpinner);

@Component({ name: "BaseImage" })
export default class BaseImage extends Vue {
  @Prop({ type: String, required: true })
  public readonly src!: string;

  @Prop({ type: String })
  public readonly alt!: string;

  @Prop({ type: Boolean, default: false })
  public readonly topRightIcon!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly topLeftIcon!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly bottomLeftIcon!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly bottomRightIcon!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly centerIcon!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly loading!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly contain!: boolean;

  @Prop({ type: Function, default: isIOS })
  public readonly isIOS!: Function;
}
